import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcommerceTrackingMapperService } from './services/ecommerce-tracking-mapper.service';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';

@NgModule({
  imports: [CommonModule, ConfigurationModule],
  providers: [EcommerceTrackingMapperService],
})
export class EcommerceMappersModule {}
